import React, { PropsWithChildren } from 'react';

import LoadingIcon from '@/components/loadingIcon';
import Typography from '@/components/typography';

type Props = PropsWithChildren<{
  loading: boolean;
}>;

export const SearchResultsHeader: React.FC<Props> = ({
  children = null,
  loading,
}) => {
  return (
    <div className="my-1 flex h-5 items-center items-center gap-x-2 px-4 py-1">
      <Typography className="text-gray-100" variant="button2">
        {children}
      </Typography>
      {loading && <LoadingIcon className="text-green-50" size="sm" />}
    </div>
  );
};
